<template>

<DataTable :value="realdata" 
responsiveLayout="scroll" 
stripedRows 
class="p-datatable-sm" 
:reorderableColumns="is_sortable"
@rowReorder="onRowReorder" 

>






<template v-if="is_sortable">
  <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
</template>






<template v-for="columnitem in columns">

<!-- text-->
<template v-if="columnitem.type=='text'">

  <template v-if="columnitem.field=='name'">
      <Column  :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
      <template #body="slotProps">

        
        <template  v-if="slotProps.data[columnitem.field].length>1">           
           <router-link  class="text-primary p-link no-underline" :to="{ name: routename , params: { [identifiername]: slotProps.data[identifier] }}">{{getTheTranslation(slotProps.data,"translation")}}</router-link>
        </template>
        
      
      </template>
      </Column>
  </template>





  <template v-else>
    <template v-if="columnitem.with_route">


      <Column  :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
      <template #body="slotProps">

          <router-link  class="text-primary p-link no-underline" :to="{ name: routename , params: { [identifiername]: slotProps.data[identifier] }}">{{getTheTranslation(slotProps.data[columnitem.field],"translation")}}</router-link>
        
      </template>
      </Column>

    </template>

    <template v-else>
        <Column  :field="columnitem.field" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
          <template #body="slotProps">
            {{getTheTranslation(slotProps.data[columnitem.field],"translation")}}

          </template>

        </Column>
       
    </template>  

  </template>






</template>
<!-- text-->

<Column  v-if="columnitem.type=='date'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data[columnitem.field]," Do-MM-YYYY HH:mm")}}</p>
</template>
</Column>

<Column  v-if="columnitem.type=='justdate'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data[columnitem.field]," Do-MM-YYYY")}}</p>
</template>
</Column>

<Column  v-if="columnitem.type=='daterelation'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ $filters.momentFormat( slotProps.data[columnitem.field][columnitem.relation_field]," Do-MM-YYYY")}}</p>
</template>
</Column>


<Column  v-if="columnitem.type=='boolean'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p v-html="$filters.booleanView( slotProps.data[columnitem.field])"></p>
</template>
</Column>



<Column  v-if="columnitem.type=='slider'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<ProgressBar :value=" slotProps.data[columnitem.field]"></ProgressBar>
</template>
</Column>




<Column  v-if="columnitem.type=='count'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ slotProps.data[columnitem.field].length}}</p>
</template>
</Column>



<template v-if="columnitem.type=='relation'">
<template v-if="columnitem.with_route">
<Column  :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">


<router-link  class="text-primary p-link no-underline" :to="{ name: routename , params: {id:slotProps.data[identifier]}}">{{ slotProps.data[columnitem.field][columnitem.relation_field]}}</router-link>
</template>
</Column>

</template>
<template v-else>
<Column  :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ slotProps.data[columnitem.field][columnitem.relation_field]}}</p>
</template>
</Column>
</template>

</template>







<Column  v-if="columnitem.type=='pill'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">

<!--<p>{{ slotProps.data[columnitem.field][columnitem.relation_field]}}</p>-->
<Tag 
class="mr-2 mt-1 custom-chip" 
v-for=" element in columnitem.options"  
v-show="element.name==slotProps.data[columnitem.field]"
:value="this.$store.state.languages.lang_phrases[element.text]" 
:style="'background-color:'+element.color"

/>
</template>
</Column>


<Column  v-if="columnitem.type=='color'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">

<!--<p>{{ slotProps.data[columnitem.field][columnitem.relation_field]}}</p>-->
<Tag 
class="mr-2 mt-1 custom-chip"  
v-if="slotProps.data[columnitem.field]"
:style="'background-color:'+slotProps.data[columnitem.field]"

/>
</template>
</Column>




<template v-if="columnitem.type=='deeprelation'">
<template v-if="columnitem.with_route">
<Column  :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">

<router-link  class="text-primary p-link no-underline" :to="{ name: routename , params: {id:slotProps.data[identifier]}}">{{ slotProps.data[columnitem.field][columnitem.deepfield][columnitem.relation_field]}}</router-link>
</template>
</Column>

</template>
<template v-else>
<Column  :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}">
<template #body="slotProps">
<p>{{ slotProps.data[columnitem.field][columnitem.deepfield][columnitem.relation_field]}}</p>
</template>
</Column>
</template>

</template>

<Column  v-if="columnitem.type=='relationarray'" :header="$store.state.languages.lang_phrases[columnitem.header]" :class="{'hide_on_mobile_table_cell':columnitem.hide_on_mobile}" style="max-width: 8rem">
<template #body="slotProps">
<Tag  v-for="(element,index) in  slotProps.data[columnitem.field]" :key="element.id" :value="element[columnitem.relation_field]" class="mr-2 " style="text-transform: capitalize"/>
</template>
</Column>



</template>




<!--
<Column headerStyle="width: 8rem; text-align: center" bodyStyle="text-align: center; overflow: visible" class="hide_on_mobile_table_cell">
<template #body="slotProps">
<div>	
<Button type="button" icon="pi pi-eye" class=" p-button-primary p-button-outlined  p-button-sm mr-2" @click="gotoPage(routename,{id:slotProps.data.id})"></Button>
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm" @click="deleteItem(deleteobjectname,slotProps.data.id)"></Button>
</div>
</template>
</Column>
-->

<Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible" class="">
<template #body="slotProps">
 <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,slotProps.data.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+slotProps.data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
<Menu :id="'overlay_menu'+slotProps.data.id" :ref="'menu'+slotProps.data.id" :model="items" :popup="true">
 <template #item="{item}">  
  <template v-if="item.label=='Sil' || item.label=='Delete'">
    <template v-if="deleteobjectname">
      <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(item.argument,{[identifiername]:slotProps.data[identifier]})"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
    </template>
  </template>
  <template v-else>
    <a class="p-menuitem-link" 
      role="menuitem" 
      @click="item.command(item.argument,{[identifiername]:slotProps.data[identifier]})"
      >
      <span :class="'p-menuitem-icon '+item.icon"></span>
      <span class="p-menuitem-text">{{item.label}}</span>
      <span class="p-ink"></span></a>
  </template>

</template>
</Menu>
</template>
</Column>



</DataTable>



</template>

<script>
export default {
  props:["data","columns","routename","deleteobjectname","identifier_row","identifier_row_name","sortable"],
  name: 'ContentTableExtended',

  data () {
    return {
    	items: [
    		{
                label: this.$store.state.languages.lang_phrases.goruntule,
                icon: 'pi pi-eye',
                argument:this.routename,
                command: (argument,id) => {
                	console.log(argument)
                	console.log(id)
                  //return false
	                   this.gotoPage(argument,id)
	                }
            },
            {
                label: this.$store.state.languages.lang_phrases.sil,
                icon: 'pi pi-trash',
                argument:this.deleteobjectname,
                command: (argument,id) => {
                  console.log(argument)
                  console.log(id)
                  //return false
	                   this.deleteItem(argument,id)
	                }
            },

    	]
    }
  },
  methods:{
    onRowReorder(event)
    {
      console.log(event)
      this.$emit("rowsReorders",event.value)
    },
  	toggle(event,id) {
      
      //return false
        this.$refs['menu'+id].toggle(event);
    },
  },
  computed:{
    realdata()
    {
      return this.data
    },
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	},
    identifier()
    {
      if(this.identifier_row)
      {
        return this.identifier_row
      }
      else
      {
        return "id"
      }
    },
    identifiername()
    {
      if(this.identifier_row_name)
      {
        return this.identifier_row_name
      }
      else
      {
        return "id"
      }
    },
    is_sortable()
    {
      if(this.sortable)
      {
        return true
      }
      else
      {
        return false
      }
    },
    preflang_id()
    {
      console.log("pref")
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
  			this.$emit("dataDeleted")
  		}
  	},
    preflang_id(newval)
    {
      console.log("preflang")
      console.log(this.$store.state.languages.lang_phrases.goruntule)
      setTimeout(()=>{
        this.items[0].label = this.$store.state.languages.lang_phrases.goruntule
        this.items[1].label = this.$store.state.languages.lang_phrases.sil
      },500)
      
    }
  }
};
</script>

<style lang="css" scoped>
</style>